import React from 'react';
import { LockIcon } from 'lucide-react';
export function FormPreviewNotice() {
  return <p className="flex gap-2.5 text-[13px] leading-relaxed text-muted" data-id="element-68" data-mp="19jvl8uh5d8xh">
      <LockIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-gold-deep" aria-hidden="true" data-id="element-69" data-mp="19l6n2or186ly" />
      <span data-id="element-70" data-mp="usd5mxs79gen">
        Secure online submission is not yet connected. Details entered here are checked in your browser only — nothing
        is transmitted, uploaded or stored.
      </span>
    </p>;
}